export const DEPOSIT_MODAL = 'modals/DepositModal';
export default {
    DEPOSIT_MODAL,
};



// WEBPACK FOOTER //
// ./src/constants/modalNames.js